import { useQuery } from '@tanstack/react-query';
import { fetchMyInvites } from '@/services/invite';
export const useMyInvites = () => useQuery({
    queryKey: ['my-invites'],
    queryFn: fetchMyInvites,
    staleTime: 60_000,
});
